<template>
  <div class="comment-box">
    <div
      class="comment"
      :class="{ 'with-cursor': editable }"
      @click.stop="editable && emit('edit')"
    >
      <div class="comment-title-content">
        <div class="comment-title">{{ comment.title }}</div>
        <div class="comment-content">{{ comment.content }}</div>
      </div>
      <div class="comment-delete">
        <IconButton
          v-if="editable"
          size="small"
          class="comment-delete__button"
          name="delete"
          variant="outline"
          type="destructive"
          @click.stop="emit('delete')"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { IconButton } from '@/components/IconButton'

  defineProps<{ comment: { content: string; title: string }; editable: boolean }>()
  const emit = defineEmits<{ delete: []; edit: [] }>()
</script>
